import api from "../api/services";

export default {
  getUser: async function ({ commit }) {
    return api.user().then((response) => {
      commit("setUser", response.data);
    });
  },
  ping: async function () {
    return api.ping();
  },
};
